import classnames from 'classnames';
import IconNext from './icon_next.svg';
import IconPrev from './icon_prev.svg';
import s from './index.module.scss';

export const SliderNavigation = ({ params, onNext, onPrev }) => (
  <>
    <button
      type="button"
      className={classnames(s.prev, 'hov', params.isBeginning && 'hidden')}
      onClick={() => onPrev()}
    >
      <img src={IconPrev} alt="prev" width={20} height={20} />
    </button>
    <button
      type="button"
      className={classnames(s.next, 'hov', params.isEnd && 'hidden')}
      onClick={() => onNext()}
    >
      <img src={IconNext} alt="next" width={20} height={20} />
    </button>
  </>
);
